import { ApiError } from '../../api/client';
import { UploadRejectedError, UploadTransportError } from '../../api/uploads';

const messages: Record<string, string> = {
  clones_unavailable: 'Свои голоса временно недоступны. Попробуйте обновить список позже.',
  voice_unavailable: 'Сервис голосов временно недоступен. Попробуйте ещё раз позже.',
  entitlement_unavailable: 'Не удалось подтвердить лимит голосов. Обновите список позже.',
  identity_unavailable: 'Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.',
  voice_name_invalid: 'Имя голоса должно содержать от 2 до 32 символов.',
  voice_description_invalid: 'Описание должно содержать не больше 120 символов.',
  samples_invalid: 'Добавьте от 1 до 10 подходящих образцов.',
  preview_unavailable: 'Превью этого голоса пока недоступно.',
  voice_preview_not_found: 'Превью этого голоса пока недоступно.',
  voice_preview_unavailable: 'Не удалось загрузить превью. Попробуйте позже.',
  low_quality: 'Слишком шумная запись. Попробуйте записать голос в тихом месте.',
  multiple_speakers: 'В записи слышно несколько голосов. Добавьте речь одного человека.',
  policy_rejected: 'Голос не прошёл правила площадки.',
  provider_failed: 'Сервис не смог обработать голос. Проверьте статус перед повтором.',
  voice_invalid: 'Не удалось создать голос. Проверьте данные и образцы.',
  voice_limit_reached: 'Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.',
  clone_creation_unavailable: 'Создание голосов временно недоступно. Образцы сохранены в этом окне.',
  consent_invalid: 'Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.',
  consent_required: 'Подтвердите согласие перед отправкой образцов.',
  consent_version_invalid: 'Версия согласия изменилась. Обновите страницу.',
  consent_version_changed: 'Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.',
  sample_duration_invalid: 'Нужно от 2 секунд до 1,5 минуты речи в сумме.',
  upload_not_ready: 'Образец ещё не проверен. Подождите и продолжите отправку.',
  unsupported_media_type: 'Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.',
  version_conflict: 'Голос изменился. Данные обновлены — проверьте их перед сохранением.',
  voice_not_found: 'Голос уже удалён или недоступен.',
  verification_failed: 'Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.',
  speaker_verification_failed: 'Проверка голоса не пройдена. Запишите образец без музыки и других людей.',
  retry_not_allowed: 'Этот запуск пока нельзя повторить. Обновите статус голоса.',
  voice_not_retryable: 'Этот запуск пока нельзя повторить. Обновите статус голоса.',
  consent_unavailable: 'Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.',
  sample_too_short: 'Образец короче 2 секунд',
  internal: 'Внутренняя ошибка, попробуйте позже',
  provider_outcome_unknown:'Результат обработки уточняется. Повторный запуск пока недоступен.',
};

export function cloneError(error: unknown): string {
  if (error instanceof UploadRejectedError) return 'Образец не прошёл проверку. Выберите другую запись.';
  if (isDefiniteUploadRejection(error))
    return 'Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.';
  if (error instanceof UploadTransportError)
    return 'Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.';
  if (error instanceof ApiError) {
    if (messages[error.code]) return messages[error.code];
    if (error.status === 429) return 'Слишком много запросов. Подождите немного и попробуйте ещё раз.';
    if (error.status === 401) return 'Не удалось войти. Откройте приложение из Telegram заново.';
  }
  return 'Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.';
}

/** Причина неудачного обучения голоса (error_code записи): неизвестный код — «Внутренняя ошибка», а не сообщение о сетевом сбое */
export function voiceErrorText(code: string): string {
  return messages[code] ?? messages.internal;
}

export function isDefiniteUploadRejection(error: unknown): error is UploadTransportError {
  return error instanceof UploadTransportError && (error.message === 'upload_url_expired' ||
    /^upload_put_failed_(400|401|403|404|410|413|415|422)$/.test(error.message));
}

export const timeLabel = (ms: number) => {
  const seconds = Math.floor(ms / 1000);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};
